import React from 'react';
import spinner from '../../assets/images/white-spinner.svg';
import greenSpinner from '../../assets/images/green-spinner.svg';

export const Spinner = () => {
  return <img alt='' src={spinner} />;
};

export const PageSpinner = () => {
  return (
    <div className='page-loading'>
      <img src={greenSpinner} alt='' />
    </div>
  );
};
